<template>
  <el-row>
    <el-col>
      <el-card>
        <el-row>
          <el-col>
            <el-tabs v-model="activeTab">
              <el-tab-pane name="KpiSoporteTecnico" label="SLA">
                <KpiSoporteTecnico />
              </el-tab-pane>

              <el-tab-pane
                name="KpiSoporteTecnicoGerencia"
                label="SLA Gerencia"
              >
                <KpiSoporteTecnicoGerencia />
              </el-tab-pane>
            </el-tabs>
          </el-col>
        </el-row>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import KpiSoporteTecnico from "./KpiSoporteTecnico.vue";
import KpiSoporteTecnicoGerencia from "./KpiSoporteTecnicoGerencia.vue";

export default {
  data() {
    return {
      activeTab: "KpiSoporteTecnico"
    };
  },

  components: {
    KpiSoporteTecnico,
    KpiSoporteTecnicoGerencia
  }
};
</script>

<style></style>
